import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class CatalogService {
    public setupAPI: string = "/svcs/session_catalog/setup";
    public setupAttendeeAPI: string = "/svcs/session_catalog/app/sessionCatalog";
    public setupConfigAPI: string = "/svcs/session_catalog/setup/config";

    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public findByCatalogUUID(catalogUUID) {
        let url;
        if (this.sharedService.redirectTo == "admin" || this.sharedService.redirectTo == "preview") {
            url = this.setupAPI;
        } else {
            url = this.setupAttendeeAPI;
        }

        return this.http.get(url + "?catalogUUID=" + catalogUUID, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public findByCatalogUUIDES(catalogUUID) {
        let url = this.setupAttendeeAPI;

        return this.http.get(url + "?catalogUUID=" + catalogUUID, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public saveSetup(setup: any) {
        let url = this.setupAPI;
        if (setup.id != null) {
            url = url + "/" + setup.id;
        }
        return this.http.post(url, JSON.stringify(setup), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public publishCatalog(setupConfig: any) {
        let url = this.setupAPI +  "/publish";
        return this.http.post(url, JSON.stringify(setupConfig), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public saveSetupConfig(setupConfig: any) {
        let url = this.setupConfigAPI;
        if (setupConfig.id != null) {
            url = url + "/" + setupConfig.id;
        }
        return this.http.post(url, JSON.stringify(setupConfig), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getCustomFieldList(params) {
        let url = "/svcs/session_catalog/app/confCustomField?active=true&limit=-1&name=&name.dir=asc&page=0&sort=name";
        return this.http.get(url, {
            params: params,
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public saveCss(formData: FormData) {
        this.sharedService.isUpload = true;
        return this.http.post(
            `/svcs/api/3.1/accounts/${this.sharedService.accountUUID}/events/${this.sharedService.eventUUID}/assetsv2`,
            formData,
            {
                observe: "response",
                headers: {}
            }
        );
    }

    public getLayoutConfig(catalogUUID) {
        return this.http.get(`/svcs/session_catalog/app/layout_config` + "?catalogUUID=" + catalogUUID,
            {
                observe: "response",
                headers: this.sharedService.headers
            })
    }
}
